const getInitialFromPart = (part) => {
  const normalizedPart = String(part || "").trim();
  const withoutLatinFamilyPrefix = normalizedPart.replace(/^al[-\s]?/i, "");
  const withoutArabicFamilyPrefix = withoutLatinFamilyPrefix.replace(/^ال/, "");
  const resolvedPart = withoutArabicFamilyPrefix || normalizedPart;

  return resolvedPart.charAt(0);
};

export const getUserInitials = (name, maxInitials = 2) => {
  const normalizedName = String(name || "").trim();
  if (!normalizedName) return "";

  const parts = normalizedName.split(/\s+/).filter(Boolean);
  if (parts.length > 1) {
    const selectedParts =
      maxInitials === 1 ? [parts[0]] : [parts[0], parts[parts.length - 1]];

    const chars = selectedParts.slice(0, maxInitials).map(getInitialFromPart);
    const isArabic = chars.some((c) => /[\u0600-\u06FF]/.test(c));
    return chars.join(isArabic ? " " : "").toUpperCase();
  }

  return normalizedName.slice(0, maxInitials).toUpperCase();
};
